<template>
  <div
    v-on-click-outside="closeRewards"
    data-testid="loyalty-rewards-header"
    @mouseenter="openRewards"
    @mouseleave="handleClose"
  >
    <div
      class="pa-0"
      role="button"
      tabindex="0"
      data-testid="loyalty-rewards-trigger"
      :aria-label="$t('label.stampinRewards')"
      :aria-expanded="rewardsOpen"
      aria-controls="loyalty-rewards-panel"
      style="position: relative; max-width:24px; max-height:24px;"
      @click="toggleRewards"
      @keydown="onKeydown"
    >
      <SIcon :icon="icons.mdiGiftOutline" color="primary" class="icon-hover" decorative />
    </div>
    <LoyaltyRewardsInfo
      v-if="rewardsOpen"
      id="loyalty-rewards-panel"
      header
      @close="closeRewards"
      @mouseenter="clearCloseTimeout"
      @mouseleave="handleClose"
    />
  </div>
</template>
<script setup lang="ts">
import { mdiGiftOutline } from '@mdi/js'
import LoyaltyRewardsInfo from '~/components/base/LoyaltyRewardsInfo.vue'
import { vOnClickOutside } from '@vueuse/components'
import { useHeaderLayers } from '~/composables/useHeaderLayers'
import { useKeyboardActivation } from '~/composables/useKeyboardActivation'

const icons = { mdiGiftOutline }

const layers = useHeaderLayers()
const rewardsOpen = ref(false)

let closeTimeout: ReturnType<typeof setTimeout> | null = null

watch(rewardsOpen, (open) => {
  if (open) {
    layers.open('rewards')
    document.addEventListener('keydown', handleDocumentKeydown)
  } else {
    layers.close('rewards')
    document.removeEventListener('keydown', handleDocumentKeydown)
  }
})
watch(layers.activeLayer, (layer) => {
  if (layer !== 'rewards' && rewardsOpen.value) {
    rewardsOpen.value = false
  }
})

const clearCloseTimeout = () => {
  if (closeTimeout) {
    clearTimeout(closeTimeout)
    closeTimeout = null
  }
}

const openRewards = () => {
  clearCloseTimeout()
  rewardsOpen.value = true
}

const closeRewards = () => {
  clearCloseTimeout()
  rewardsOpen.value = false
}

function handleDocumentKeydown(event: KeyboardEvent) {
  if (event.key === 'Escape') {
    closeRewards()
  }
}

const toggleRewards = () => {
  clearCloseTimeout()
  rewardsOpen.value = !rewardsOpen.value
}

const handleClose = () => {
  clearCloseTimeout()
  closeTimeout = setTimeout(() => {
    rewardsOpen.value = false
    closeTimeout = null
  }, 200)
}

const onKeydown = useKeyboardActivation(toggleRewards)

onUnmounted(() => {
  if (closeTimeout) {
    clearTimeout(closeTimeout)
  }
  document.removeEventListener('keydown', handleDocumentKeydown)
})

</script>
<style lang="scss" scoped>
</style>
